import { Link } from 'react-router-dom'
import { useInterestQuery } from '@/store/api'
import { PageHeader } from '@/components/layout/AppShell'
import { Table, THead, Th, Tr, Td, SkeletonRows } from '@/components/ui/data-table'
import { EmptyState, ErrorState } from '@/components/ui/empty-state'
import { Tooltip } from '@/components/ui/tooltip'
import { fmtDateTime, fmtNum, fmtRelative } from '@/lib/format'

/** Upsell-card clicks the WHMCS module reports, by brand and offer — for the partnerships team. */
export function PartnerInterest() {
  const { data, isLoading, isError, refetch } = useInterestQuery()
  return (
    <>
      <PageHeader
        title="Partner interest"
        description="Clicks on the upsell cards in each partner's WHMCS module, by offer. A brand clicking an offer it doesn't have yet is a lead for the partnerships team."
      />
      {isError ? (
        <ErrorState onRetry={refetch} />
      ) : !isLoading && data?.length === 0 ? (
        <EmptyState title="No clicks reported yet" />
      ) : (
        <Table>
          <THead>
            <Th>Brand</Th>
            <Th>Offer</Th>
            <Th right>Clicks</Th>
            <Th>Last click</Th>
          </THead>
          {isLoading ? (
            <SkeletonRows cols={4} />
          ) : (
            <tbody>
              {data!.map((r) => (
                <Tr key={`${r.partnerId}-${r.offer}`}>
                  <Td className="font-medium">
                    <Link to={`/admin/partners`} className="hover:underline">
                      {r.partnerName}
                    </Link>
                  </Td>
                  <Td>{r.offer}</Td>
                  <Td right>{fmtNum(r.clicks)}</Td>
                  <Td>
                    <Tooltip content={fmtDateTime(r.lastAt)}>
                      <span>{fmtRelative(r.lastAt)}</span>
                    </Tooltip>
                  </Td>
                </Tr>
              ))}
            </tbody>
          )}
        </Table>
      )}
    </>
  )
}
